import axios from 'axios'
import baseStore from '../../index'

const state = {
  token: localStorage.getItem("token") ?? null,
  loading: false
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  LOGIN_PENDING (state) {
    state.loading = true;
  },
  LOGIN_SUCCESS(state) {
    state.loading = false
  },
}

const actions = {
  async login({ commit }) {
    // commit('SET_OFFLINE', isOffline)
    // commit('LOGIN_PENDING')
    // if (isOffline) {
    //   console.log(mainStore.getters.offlineMode)
    //   try {
    //     const token = localStorage.getItem('token')
    //     const email = localStorage.getItem('userEmail')
    //     const userName = localStorage.getItem('userName')
    //     commit('SET_TOKEN', token)
    //     commit('SET_USER_EMAIL', email)
    //     commit('SET_USER_NAME', userName)
    //     commit('LOGIN_SUCCESS')
    //     console.log(`offline set successfully ${token} ${email} ${userName}`)
    //     return 'all good!'
    //   } catch (e) {
    //     console.log(`unable to set offline, error ${e}`)
    //     return Error(
    //       'User not logged in, try to login in online mode first and retry later'
    //     )
    //   }
    // } else {
    commit('LOGIN_PENDING')
    if (process.env.NODE_ENV === 'development') {
      console.log('login')
      await axios.post(baseStore.getters.apiPath +'login')
        .then((response) => {
          //console.log(response)
          localStorage.setItem('token', response.data.token)
          localStorage.setItem('userEmail', response.data.userEmail)
          localStorage.setItem('userName', response.data.userName)
          commit('SET_TOKEN', response.data.token)
          commit('LOGIN_SUCCESS')
          return response
        })
        .catch((error) => {
          global.showError(error)
          console.log("POST call unsuccessful :(", error);
      });
    } else {
      window.top.location = baseStore.getters.apiPath +'login'
    }
    // }
  },
  logout({ commit, dispatch }) {
    if (process.env.NODE_ENV === 'development') {
      return new Promise((resolve) => {
        dispatch('resetLocalStorage')
        commit('SET_TOKEN', null)
        resolve()
      })
    } else {
      dispatch('resetLocalStorage')
      commit('SET_TOKEN', null)
    }
  },
  resetLocalStorage() {
    console.log('resetLocalStorage')
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('userEmail')
    localStorage.removeItem('userName')
    localStorage.removeItem('bookingItems')
    localStorage.removeItem('contactsList')
    localStorage.removeItem('eventsList')
    localStorage.removeItem('fairItems')
  }
}

const getters = {
  token: (state) => state.token,
  loading: state => state.loading
};

const loginModule = {
  state,
  mutations,
  actions,
  getters,
}

export default loginModule
